export const LIST = "MEMBER_REBATE_LIST";
export const DROPDOWN = "MEMBER_REBATE_DROPDOWN";
export const HISTORY = "MEMBER_REBATE_HISTORY";
export const ROLLOVER_DETAILS = "MEMBER_REBATE_ROLLOVER_DETAILS";
export const STORE = "MEMBER_REBATE_STORE";
